/* eslint-disable */
const getters = {
  getCollection(state) {
    return {
      ...state.data,
      photoable_type: 'App\\Collection',
    };
  },
  getIsLoading(state) {
    return state.isLoading;
  },
};

export default getters;
